/**
 * Pubblica in `--h-intestazione` l'altezza di cio' che sta sopra l'apertura.
 *
 * Serve a una cosa sola: un'apertura "a schermo intero" alta `100svh` non
 * riempie lo schermo, lo SUPERA. L'intestazione e la barra annunci stanno nel
 * flusso prima di lei, quindi il fondo dell'apertura finisce piu' in basso del
 * bordo della finestra esattamente di quanto sono alte loro — e li' sta il
 * pulsante, che sparisce sotto la piega. Su desktop e su telefono uguale.
 *
 * L'altezza non e' una costante: dipende dal logo, dal testo della barra
 * annunci (che su schermo stretto va a capo) e dal corpo del carattere. Si
 * misura, non si indovina.
 *
 * Il foglio di stile ha un ripiego prudente per chi non esegue JavaScript:
 * generoso, perche' sbagliare per eccesso accorcia un po' l'apertura mentre
 * sbagliare per difetto ritaglia via il pulsante.
 */
const SOPRA = ['.announcement', '.header'];

const misura = () => {
  let altezza = 0;
  for (const selettore of SOPRA) {
    const el = document.querySelector(selettore);
    // `getBoundingClientRect` e non `offsetHeight`: tiene conto dei decimali,
    // e mezzo pixel per due elementi basta a far ricomparire una barra di
    // scorrimento verticale che non serve a niente.
    if (el) altezza += el.getBoundingClientRect().height;
  }
  document.documentElement.style.setProperty('--h-intestazione', `${altezza.toFixed(1)}px`);
};

misura();

// La barra annunci cambia altezza quando il testo va a capo, e succede
// ruotando il telefono senza che nessuna pagina venga ricaricata.
if (typeof ResizeObserver === 'function') {
  const osservatore = new ResizeObserver(misura);
  for (const selettore of SOPRA) {
    const el = document.querySelector(selettore);
    if (el) osservatore.observe(el);
  }
}

// I caratteri arrivano dopo il primo disegno e cambiano l'altezza del testo.
if (document.fonts && document.fonts.ready) document.fonts.ready.then(misura);
